(function () {
  function monthToNumber(month) {
    const map = {
      january: "01", february: "02", march: "03", april: "04",
      may: "05", june: "06", july: "07", august: "08",
      september: "09", october: "10", november: "11", december: "12"
    };
    return map[(month || "").toLowerCase()];
  }

  function friendlyToISO(friendly) {
    if (!friendly) return "";

    friendly = friendly.trim();

    // e.g. "December 21st"
    const m = friendly.match(/^([A-Za-z]+)\s+(\d+)(st|nd|rd|th)?$/);
    if (!m) return "";

    const monthNum = monthToNumber(m[1]);
    if (!monthNum) return "";

    const dayNum = String(m[2]).padStart(2, "0");

    // Year strategy: choose current year unless date already passed, then next year
    const now = new Date();
    let year = now.getFullYear();
    const candidate = new Date(`${year}-${monthNum}-${dayNum}T00:00:00`);
    if (candidate < now) year += 1;

    return `${year}-${monthNum}-${dayNum}`;
  }

  // More robust: detects "pickup date" radios regardless of case / exact naming
  function isPickupDateRadio(el) {
    if (!el || el.type !== "radio") return false;

    // --- 1) Name-based detection (case-insensitive, tolerant of whitespace) ---
    const rawName = el.getAttribute("name") || "";
    const name = rawName.toLowerCase().replace(/\s+/g, " ").trim();
    if (name.includes("pickup date")) {
      return true;
    }

    // --- 2) Legend-based detection (case-insensitive "pickup" + "date") ---
    const fieldset = el.closest("fieldset");
    if (fieldset) {
      const legend = fieldset.querySelector("legend");
      if (legend) {
        const legendText = legend.textContent.toLowerCase();
        if (legendText.includes("pickup") && legendText.includes("date")) {
          return true;
        }
      }
    }

    return false;
  }

  function updateHiddenForRadio(radio) {
    const formId = radio.getAttribute("form");
    let form = formId ? document.getElementById(formId) : radio.closest("form");
    if (!form) return;

    const friendly = (radio.value || "").trim();
    const iso = friendlyToISO(friendly);

    // Prefer scoping to the form by name; fall back to ID pattern if needed
    const friendlyInput =
      form.querySelector('input[name="properties[pickup_date]"]') ||
      (formId
        ? document.getElementById(`pickup_date_hidden_${formId}`)
        : null);

    const isoInput =
      form.querySelector('input[name="properties[pickup_date_iso]"]') ||
      (formId
        ? document.getElementById(`pickup_date_iso_hidden_${formId}`)
        : null);

    if (friendlyInput) friendlyInput.value = friendly;
    if (isoInput) isoInput.value = iso;

    if (window.console && console.log) {
      console.log("[pickup_date] updated", {
        formId: formId || (form && form.id),
        friendly,
        iso
      });
    }
  }

  function initExisting() {
    const radios = Array.from(
      document.querySelectorAll('input[type="radio"]')
    ).filter(isPickupDateRadio);

    radios.forEach((r) => {
      if (r.checked) {
        updateHiddenForRadio(r);
      }
    });
  }

  // Capture phase in case theme does funky stuff
  document.addEventListener(
    "change",
    function (e) {
      const t = e.target;
      if (!isPickupDateRadio(t)) return;
      updateHiddenForRadio(t);
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initExisting);
  } else {
    initExisting();
  }

  // If your theme swaps DOM on variant changes, re-run init
  document.addEventListener("variant:change", initExisting);
})();
